import { render, staticRenderFns } from "./CustomizationDemoModal.vue?vue&type=template&id=4c4b31b0"
import script from "./CustomizationDemoModal.vue?vue&type=script&lang=js"
export * from "./CustomizationDemoModal.vue?vue&type=script&lang=js"
import style0 from "./CustomizationDemoModal.vue?vue&type=style&index=0&id=4c4b31b0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports